import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'app-mathjax',
    templateUrl: './mathjax.component.html',
    styleUrls: ['./mathjax.component.css'],
    standalone: false
})
export class MathjaxComponent implements OnInit, OnChanges {
  @Input() content: string;
  @ViewChild('mathContent') mathContent: ElementRef;
  mathJaxObject;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content']) {
      this.renderMath();
    }
  }

  renderMath() {
    this.mathJaxObject = window['MathJax'];
    let angObj = this;
    setTimeout(() => {
      if (angObj.mathJaxObject && angObj.mathJaxObject.Hub) {
        angObj.mathJaxObject.Hub.Queue(
          ['Typeset', angObj.mathJaxObject.Hub],
          angObj.mathContent.nativeElement);
      }
    }, 1000);
  }

  loadMathConfig() {
    this.mathJaxObject = window['MathJax'];
    if (this.mathJaxObject && this.mathJaxObject.Hub) {
        this.mathJaxObject.Hub.Config({
        showMathMenu: false,
        tex2jax: {inlineMath: [['$', '$'], ['\\(', '\\)']]},
        menuSettings: { zoom: 'Double-Click', zscale: '150%' },
        CommonHTML: { linebreaks: { automatic: true } },
        'HTML-CSS': { linebreaks: { automatic: true } },
        SVG: { linebreaks: { automatic: true } }
        });
    }
  }

  ngOnInit() {
    this.loadMathConfig();
    this.renderMath();
  }
}
